import { sendSumoLog } from './sumoLogger';
import { updateError } from '../../store';
import { DELETE_STANDBY_INSPECTOR } from '../queries/queries';
import { fetchStandbyInspectorsList } from './fetchStandbyInspectorsList';
import GetApolloClient from '../../Apollo';

/**
 * Delete a Standby Inspector.
 *
 * @param token - authentication token from active auth.
 * @param dispatch - redux dispatch to dispatch state changes.
 * @param inspectorId - the id of the Standby Inspector record to delete.
 * @returns {Promise<[StandbyInspectors]>} - The updated list of Standby Inspectors.
 */
export const deleteStandbyInspector = async (token, dispatch, inspectorId) => {
  const client = GetApolloClient(token);

  try {
    /* eslint-disable no-unused-vars */
    const {
      data: {
        deleteStandbyInspector: { id },
      },
    } = await client.mutate({
      mutation: DELETE_STANDBY_INSPECTOR,
      variables: { id: inspectorId },
    });

    fetchStandbyInspectorsList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'deleteStandbyInspector';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
